import React from "react";
import { FileText, Download, FileBadge, Newspaper } from "lucide-react";
import { PageHero, Section, Card } from "@/components/Section";
import { IMAGES } from "@/lib/site";
import { toast } from "sonner";

const docs = [
  {
    icon: FileBadge,
    titre: "Plaquette de présentation",
    description: "Découvrez en quelques pages notre projet éducatif et nos formations.",
    fichier: "plaquette-lycee-wresinski.pdf",
  },
  {
    icon: FileText,
    titre: "Dossier d'inscription 2026",
    description: "À compléter et nous retourner pour candidater dans l'une de nos filières.",
    fichier: "dossier-inscription-2026.pdf",
  },
  {
    icon: Newspaper,
    titre: "Calendrier scolaire 2025-2026",
    description: "Toutes les dates clés de l'année : vacances, conseils de classe, examens.",
    fichier: "calendrier-2025-2026.pdf",
  },
  {
    icon: FileText,
    titre: "Règlement intérieur",
    description: "Les règles de vie au lycée, rédigées en concertation avec les élèves.",
    fichier: "reglement-interieur.pdf",
  },
];

export default function Telechargements() {
  const onDownload = (fichier) => {
    toast.info(
      `Le document « ${fichier} » sera bientôt disponible. Contactez le secrétariat pour le recevoir par email.`
    );
  };

  return (
    <div data-testid="telechargements-page">
      <PageHero
        eyebrow="Espace téléchargement"
        title="Documents utiles à télécharger"
        subtitle="Retrouvez ici tous les documents indispensables pour préparer votre inscription ou suivre la vie de l'établissement."
        image={IMAGES.abstract}
      />

      <Section>
        <div className="grid gap-6 sm:grid-cols-2">
          {docs.map((d, i) => (
            <Card key={d.fichier} data-testid={`doc-${i}`}>
              <div className="flex items-start gap-5">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-brand-sand/30 text-brand-slate-dark">
                  <d.icon className="h-5 w-5" />
                </span>
                <div className="flex-1">
                  <h3 className="font-heading text-lg font-bold text-brand-slate-dark">{d.titre}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{d.description}</p>
                  <button
                    type="button"
                    onClick={() => onDownload(d.fichier)}
                    data-testid={`download-${i}`}
                    className="mt-5 inline-flex items-center gap-2 rounded-full bg-brand-slate px-5 py-2.5 text-sm font-semibold text-brand-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-slate-dark"
                  >
                    <Download className="h-4 w-4" /> Télécharger le PDF
                  </button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="mt-12 rounded-3xl bg-brand-sand-wrapper/50 p-8 text-sm text-muted-foreground">
          <p>
            <span className="font-semibold text-brand-slate-dark">Besoin d'un document spécifique ?</span>{" "}
            Notre secrétariat se tient à votre disposition pour vous transmettre par email les documents
            dont vous auriez besoin.
          </p>
        </div>
      </Section>
    </div>
  );
}
